<template>
  <div class="app-main-content">
    <div>
      <h1>Update Address</h1>
      <div><SystemAlert/></div>
      <slot v-if="addressUpdateStep == 1">
        <AddressUpdate />
      </slot>
      <slot v-if="addressUpdateStep == 2">
        <MelissaAddress />
      </slot>
      <slot v-if="addressUpdateStep == 3">
        <ConfirmAddress />
      </slot>
    </div>
  </div>
</template>

<script setup>
import { computed, onBeforeUnmount } from 'vue';
import { useStore } from 'vuex';
import SystemAlert from '@/components/SystemAlert';
import AddressUpdate from '../../components/updateAddress/AddressUpdate.vue';
import MelissaAddress from '../../components/updateAddress/MelissaAddress.vue';
import ConfirmAddress from '../../components/updateAddress/ConfirmAddress.vue';

// Vuex store
const store = useStore();

// Computed property
const addressUpdateStep = computed(() => store.state.guestLogin.addressUpdateStep);

// Lifecycle hook 
onBeforeUnmount(() => {
  store.state.guestLogin.addressUpdateStep = 1;
});
</script>
